import { Utils } from "../utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface ICostCode {
    id: number;
    contractorID: string;
    description: string;
    isArchived: boolean;
}

export class CostCode implements ICostCode {

    constructor(data?: ICostCode) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: ICostCode) {
        Utils.clone(data, this);
    }

    id: number = 0;
    contractorID: string = "";
    description: string = "";
    isArchived: boolean = false;

}